"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WAIT = void 0;
var WAIT = exports.WAIT = 400;
//# sourceMappingURL=debounce.js.map